import { render, staticRenderFns } from "./SearchIncomeTaxPayment.vue?vue&type=template&id=d56f18de&scoped=true"
import script from "./SearchIncomeTaxPayment.vue?vue&type=script&lang=js"
export * from "./SearchIncomeTaxPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56f18de",
  null
  
)

export default component.exports